import React from 'react';

// import { dotsSpinner as DotsSpinner } from 'modules/dots-spinner';

import { Icon } from 'modules/icon-bank';
import { spinner as DotsSpinner } from 'ui/views/generic/spinner';
import { getLabel } from 'utils/getLabel';
import { GLOBAL_LABELS } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { fileUploader as FileUploader } from 'modules/fileUploader';
 *
 * // render
 * <FileUploader propName='propValue'/>
 */
export const fileUploader = ( props ) => {

    const { description } = props;

    return (
        <div className='ui-file-uploader-trigger'>

            {/* button */}
            <div className='ui-file-uploader-trigger__button'>
                { props.uploaded ? 'File Uploaded' :
                <>
                    <div className= 'ui-file-uploader-trigger__textWithIcon'>
                        <Icon id= { 'fileDownload' } />
                        <span className= 'ui-file-uploader-trigger__textWithIcon__text'>
                            { getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DRAG_FILES ) }
                            <span className='ui-file-uploader-trigger__textWithIcon__text__highlighted'> { getLabel( GLOBAL_LABELS.DISPLAY_TEXT_BROWSE ) } </span>
                        </span>
                    </div>
                    <div className= 'ui-file-uploader-trigger__desc'>
                        { description }
                    </div>
                </>
                }
            </div>

            {/* spinner */}
            {
                props.isUploading ? (
                    <DotsSpinner size='x-small'/>
                ) : null
            }
           
        </div>
    );
};

// set display name
fileUploader.displayName = 'fileUploader';

// set default props
fileUploader.defaultProps = {
    uploaded: false,
};

// prop types
fileUploader.propTypes = {};
